import { CopyIcon } from "assets";
import { showSuccessMessage } from "utils";

const CopyButton = ({
  value
}) => {
  const handleClick = () => {
    navigator.clipboard.writeText(value)
    showSuccessMessage('Disalin ke Clipboard')
  }
  return (
    <div
      className="cursor-pointer flex items-center space-x-1"
      onClick={handleClick}
    >
      <p className="text-sm text-brand-default">Salin</p>
      <CopyIcon className="h-5 w-5 text-brand-default" />
    </div>
  )
}

export default CopyButton